import { ReactNode, useState } from "react";
import { Outlet } from "react-router-dom";
import { Footer, Header, Sidebar } from "../components";

function RootLayout({ children }: { children?: ReactNode }) {
  // Make children optional
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
  const [sidebarMobile, setSidebarMobile] = useState<boolean>(false)


  return (
    <div className="flex w-screen relative h-screen overflow-x-hidden bg-secondary-100">
      {/* sidebar element */}
      <Sidebar 
        sidebarOpen={sidebarOpen} 
        setSidebarOpen={setSidebarOpen} 
        sidebarMobile={sidebarMobile}
        setSidebarMobile={setSidebarMobile}
      />


      {/* body element */}
      <div className="w-full box-border flex-grow-1 min-w-0">
        {/* header element */}
        <Header setSidebarOpen={setSidebarMobile} sidebarOpen={sidebarMobile} />
        {/* content element */}
        <>
          {children}
          <Outlet /> {/* This will render the nested routes */}
        </>
        {/* footer element */}
        <Footer />
      </div>
    </div>
  );
}

export default RootLayout;
